/* tslint:disable */
/* eslint-disable */
export enum IdentificationTypeOtherEnum {
  ForeignDriversLicense = 'ForeignDriversLicense',
  KiwiAccess = 'KiwiAccess',
  FirearmsLicense = 'FirearmsLicense',
  BirthCertificate = 'BirthCertificate',
  Other = 'Other'
}
